<template>
    <div id="app">
        <div id="navbarContainer">
            <navbar ref="navbar"/>
        </div>
        <notifications group="ust" position="top center" type="warn"/>
        <keep-alive include="kart,mektup">
            <router-view :key="keyVer()"/>
        </keep-alive>
    </div>
</template>

<script>
    import navbar from "@/components/NavBar"
    import {CikisYap} from "@/api/kisi";
    import {toplamSayi} from "@/api/okunamayan";
    import store from "@/store";

    export default {
        name: 'app',
        components: {navbar},
        methods: {
            keyVer() {
                let key = window.location.href;
                if (key.indexOf('belgeler')>0){
                    return key;
                }
                let belgeTur = key.indexOf('mektup') > 0 ? 'mektup' : 'kart';
                let id = this.$route.params.id || 0;
                if (this.$store.getters.kisi && id === 0) {
                    id = (belgeTur === 'mektup') ? this.$store.getters.kisi.Id : this.$store.getters.kisi.Id;
                }

                return key + " " + belgeTur + id;
            }
        },
        computed: {},
        async created() {
            const sayi = await toplamSayi();
            store.commit('setBkCount', sayi)
        }
    }
</script>

<style lang="scss">
    @font-face {
        font-family: "Hanzala";
        src: url(~@/assets/Hanzala.ttf) format("truetype");
    }
    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        margin: 0;
        padding: 0;
        height: 100vh;
        width: 100%;
        position: relative;
    }
    mark{
        padding: 0 !important;
        background: yellow !important;
    }
</style>
